import { lazy } from 'react';

const LazyMfaScreen = lazy(() => import('./mfa-screen'));
export default LazyMfaScreen;
